export default {
      id: "icon-calendar-usage",
      viewBox: "0 0 28 28",
      url: "../icon/" + "icons.svg#icon-calendar-usage",
      toString: function () {
        return this.url;
      }
    }